/**
 * @Description
 */

import { FC, useMemo } from 'react';
import styles from './index.module.less';
import Header from '../Header';
import PPTBarChart from '../BarChart';
import cs from 'classnames';
import { floorKeep } from '@lhb/func';
import Footer from '../Footer';

const PageSix:FC<any> = ({
  storeOprationInfo,
  storeSurvivalRateInfo,
  rangeName,
  qrCode
}) => {

  // const surviveData = [
  //   { categoryName: '餐饮', poiNum: 24, one: '80%', two: '47%', three: '32%', four: '21%', five: '19%' },
  //   { categoryName: '购物', poiNum: 29, one: '45%', two: '47%', three: '32%', four: '21%', five: '19%' },
  //   { categoryName: '休闲娱乐', poiNum: 24, one: '80%', two: '47%', three: '32%', four: '21%', five: '19%' },
  //   { categoryName: '教育培训', poiNum: 24, one: '80%', two: '47%', three: '32%', four: '21%', five: '19%' },
  //   { categoryName: '酒店', poiNum: 24, one: '80%', two: '47%', three: '32%', four: '21%', five: '19%' },
  // ];

  const storeOprationData = useMemo(() => {
    if (!storeOprationInfo?.industries) return [];

    return storeOprationInfo?.industries?.slice(0, 5);
  }, [storeOprationInfo]);

  const turnToPercent = (num: any) => {
    return floorKeep(num, 100, 3) + '%';
  };

  return (
    <div className={styles['page']}>
      <Header title={`门店经营 — ${rangeName}`}/>

      <div className={styles['text']}>
        {/* 本区域经营门店共<span className={styles['text-point']}>101</span>家，其中经营时间超过1年的门店占比<span className={styles['text-point']}>68%</span>，门店经营年限适中。经营超过3年的门店中，<span className={styles['text-point']}>餐饮</span>占比最高。 */}
        {storeOprationInfo?.state || '-'}
      </div>

      <div className={styles['chart-box']}>
        <div className={styles['year-chart']}>
          <PPTBarChart
            width={752}
            height={479}
            title='各业态门店经营年限分布'
            xAxisData={storeOprationData?.map((item) => item?.categoryName) || []}
            seriesData={[{
              name: '开业3年以上',
              data: storeOprationData?.map((item) => item?.threeYearNum) || [],
              itemStyle: {
                color: '#FE7E7E',
                borderRadius: [100, 100, 0, 0]
              },
              barWidth: 20,
            },
            {
              name: '开业1-3年',
              data: storeOprationData?.map((item) => item?.twoYearNum) || [],
              itemStyle: {
                color: '#8769FF',
                borderRadius: [100, 100, 0, 0]
              },
              barWidth: 20,
            },
            {
              name: '开业1年以内',
              data: storeOprationData?.map((item) => item?.oneYearNum),
              itemStyle: {
                color: '#1A65FF',
                borderRadius: [100, 100, 0, 0]
              },
              barWidth: 20,
              barGap: '100%'
            }]}
            config={{
              title: {
                top: 451,
                left: 'center'
              },
              grid: {
                bottom: 60,
              },
              legend: {
                top: 0,
                left: 0,
                itemWidth: 15,
                itemHeight: 15,
                itemGap: 32,
                textStyle: {
                  fontSize: 16,
                  lineHeight: 22,
                  color: '#222222'
                }
              }
            }}
          />
        </div>

        <div className={styles['servive-table']}>

          <div className={styles['table-header']}>
            <div className={styles['table-header__cell']} style={{ flexGrow: 1.5, paddingLeft: 12 }}>门店数</div>
            <div className={styles['table-header__cell']}>1年</div>
            <div className={styles['table-header__cell']}>2年</div>
            <div className={styles['table-header__cell']}>3年</div>
            <div className={styles['table-header__cell']}>4年</div>
            <div className={styles['table-header__cell']}>5年</div>
          </div>

          <div className={styles['table-body']}>
            {storeSurvivalRateInfo?.slice(0, 5)?.map((item, index) => {
              return (
                <div className={styles['table-body__row']} key={index}>
                  <div className={styles['table-name']}>{item.categoryName}</div>

                  <div className={styles['table-detail']}>
                    <div className={cs(styles['table-cell'], styles['table-cell__count'])}>{item.poiNum}</div>
                    <div className={cs(styles['table-cell'], styles['table-cell__one'])}>{turnToPercent(item.oneYearRate)}</div>
                    <div className={cs(styles['table-cell'], styles['table-cell__two'])}>{turnToPercent(item.twoYearRate)}</div>
                    <div className={cs(styles['table-cell'], styles['table-cell__three'])}>{turnToPercent(item.threeYearRate)}</div>
                    <div className={cs(styles['table-cell'], styles['table-cell__four'])}>{turnToPercent(item.fourYearRate)}</div>
                    <div className={cs(styles['table-cell'], styles['table-cell__five'])}>{turnToPercent(item.fiveYearRate)}</div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className={styles['servive-table__title']}>历史各业态门店存续比例分布</div>
        </div>

        <div className={styles['footer']}>
          <Footer qrCode={qrCode}/>
        </div>
      </div>
    </div>
  );
};

export default PageSix;
